export default __webpack_public_path__ + "img/3a9cd951d29ff6be2c047a49184bf484.png";